import { IQuoteServiceVariableState } from '@/store/quote-service-variable';
import { IQuoteServiceVariableGetters } from './getters.types';
import { IQuoteServiceVariable, QuoteServiceVariable } from '@/models';

export const getters: IQuoteServiceVariableGetters = {
  getQuoteServiceVariables(
    state: IQuoteServiceVariableState
  ): IQuoteServiceVariable[] {
    return state.quoteServiceVariables.map(
      data => new QuoteServiceVariable(data)
    );
  },

  getQuoteServiceVariableById: (state: IQuoteServiceVariableState) => (
    id: number
  ): IQuoteServiceVariable | undefined => {
    const data = state.quoteServiceVariables.find(
      variable => variable.id === id
    );
    if (!data) {
      return undefined;
    }

    return new QuoteServiceVariable(data);
  },

  getQuoteServiceVariablesByService: (state: IQuoteServiceVariableState) => (
    service: number
  ): IQuoteServiceVariable[] => {
    return state.quoteServiceVariables
      .filter(variable => variable.service === service)
      .map(variable => new QuoteServiceVariable(variable));
  }
};
